import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'


export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;

    const data = ((row?.eventUnitEntries?.length > 0))
        ? row?.eventUnitEntries
        : undefined
    const ext = ((row?.extendedResults?.length > 0))
        ? row?.extendedResults
        : undefined
    const { breakPoint } = useViewport();
    return (
        <table className="table table-detail">
            <thead>
                <tr>
                    <th style={{ textAlign: "right" }} className="d-none d-xl-table-cell"><Label data="HeaderRound" /></th>
                    <th style={{ textAlign: "right" }} className="d-none d-xl-table-cell"><Label data="HeaderCode" /></th>
                    <th style={{ textAlign: "left" }}><Label data="HeaderDescription" /></th>
                    <th style={{ textAlign: "left" }}><Label data="HeaderPosition" /></th>
                    <th style={{ textAlign: "right" }}>{(breakPoint === "sm" || breakPoint === "xs")
                        ? <Label data="HeaderDD" />
                        : <Label data="HeaderDifficultyDegree" />}
                    </th>
                    <th style={{ textAlign: "right" }}><Label data="HeaderDivePoints" /></th>
                    <th style={{ textAlign: "right" }} className="d-none d-xl-table-cell"><Label data="HeaderRoundRank" /></th>
                    <th style={{ textAlign: "right" }} className="d-none d-xl-table-cell"><Label data="HeaderTotalPoints" /></th>
                    <th style={{ textAlign: "right" }} className="d-none d-xl-table-cell"><Label data="HeaderOverallRank" /></th>
                    <th style={{ textAlign: "right" }} className="d-none d-xl-table-cell"><Label data="HeaderPointsBehind" /></th>
                </tr>
            </thead>
            <tbody>
                {config && config.filter(rowConf => rowConf.code === 'PANEL').map((val, key) => {

                    let num = findArray(data, { eue_pos: [val.pos], eue_code: ['NUM'] })
                    let desc = findArray(data, { eue_pos: [val.pos], eue_code: ['DESC'] })
                    let type = findArray(data, { eue_pos: [val.pos], eue_code: ['TYPE'] })
                    let dd = findArray(data, { eue_pos: [val.pos], eue_code: ['DD'] })
                    // "A" Straight, "B" Pike, "C" Tuck and "D" Free
                    let valType = (type.eue_value === 'A')
                        ? <Label data="LabelStraight" />
                        : (type.eue_value === 'B')
                            ? <Label data="LabelPike" />
                            : (type.eue_value === 'C')
                                ? <Label data="LabelTuck" />
                                : (type.eue_value === 'D')
                                    ? <Label data="LabelFree" />
                                    : ''
                    let dive = findArray(ext, { er_code: ['DIVE'], er_pos: [val.pos] })
                    let score = findArray(ext, { er_code: ['SCORE'], er_pos: [val.pos] })

                    return (
                        <tr key={'expanded_' + row.participant.code + '_' + key}>
                            <td style={{ textAlign: "right" }} className="d-none d-xl-table-cell">{num.eue_pos}</td>
                            <td style={{ textAlign: "right" }} className="d-none d-xl-table-cell">{num.eue_value}</td>
                            <td style={{ textAlign: "left" }}>{desc.eue_value}</td>
                            <td style={{ textAlign: "left" }}>{valType}</td>
                            <td style={{ textAlign: "right" }}>{dd.eue_value}</td>
                            <td style={{ textAlign: "right" }}>{dive.er_value}</td>
                            <td style={{ textAlign: "right" }} className="d-none d-xl-table-cell">{dive.er_rank}</td>
                            <td style={{ textAlign: "right" }} className="d-none d-xl-table-cell">{score.er_value}</td>
                            <td style={{ textAlign: "right" }} className="d-none d-xl-table-cell">{score.er_rank}</td>
                            <td style={{ textAlign: "right" }} className="d-none d-xl-table-cell">{score.er_diff}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    console.log(arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults))
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
    )
});